import { MapMarkerInput, MapPoint } from "./types";

export function coordinateToMapPoint(
  coordinateString: string
): MapPoint | null {
  const coordinateList = coordinateString.split(",");
  if (coordinateList.length != 2) return null;
  return {
    lat: Number.parseFloat(coordinateList[0]),
    lng: Number.parseFloat(coordinateList[1]),
  };
}

export function getPointsOnly(mapMarkerInputs: MapMarkerInput[]) {
  return mapMarkerInputs.map((mmi) => mmi.point);
}

// Simple, fast, non-cryptographic hash to output a 32-bit integer
export function hashCode(str: string): number {
  let hash = 0;
  for (let i = 0, len = str.length; i < len; i++) {
      let chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export function safeIndex(input: number | undefined, arrayLength: number): number | null {
  if (input == undefined) return null
  if (
    !Number.isInteger(input) ||
    input < 0 ||
    arrayLength <= 0
  ) {
    return null;
  }
  return input % arrayLength;
}

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function html(strings: TemplateStringsArray, ...values: unknown[]): string {
  return strings.reduce((acc, str, i) => acc + escapeHtml(String(values[i - 1] ?? "")) + str);
}

export function getContrastingTextColor(hexColor: string) {
  hexColor = hexColor.replace("#", "");
  if (hexColor.length != 6) return "black";
  const r = parseInt(hexColor.substr(0, 2), 16);
  const g = parseInt(hexColor.substr(2, 2), 16);
  const b = parseInt(hexColor.substr(4, 2), 16);
  // Calculate brightness using the YIQ formula
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness >= 115 ? "black" : "white";
}
